<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<app-progress></app-progress>
<div class="p-8 table-list mat-typography">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{(itemObservable | async)?.customerPartNumber}}</mat-card-title>
        </mat-card-header>
    <mat-card-content>
      <mat-grid-list cols="4" rowHeight="30px" class="item-details">
        <mat-grid-tile colspan="1"><h4><b>Unique Item ID:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.uniqueItemId}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Tag:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.tag}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Facility:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(facility | async)?.name}}</h4></mat-grid-tile>
        @if (item !== null && item.location !== null) {
          <mat-grid-tile colspan="1"><h4><b>Location:</b></h4></mat-grid-tile>
        }
        @if (item !== null && item.location !== null) {
          <mat-grid-tile colspan="3"><h4>{{(location | async)?.name}}</h4></mat-grid-tile>
        }
        @if (item !== null && item.coordinates != null) {
          <mat-grid-tile colspan="1"><h4><b>Location Map:</b></h4></mat-grid-tile>
        }
        @if (item !== null && item.coordinates != null) {
          <mat-grid-tile colspan="3">
            <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={{item.coordinates.latitude}},{{item.coordinates.longitude}}">View item location on Google Map</a>
          </mat-grid-tile>
        }
        <mat-grid-tile colspan="1"><h4><b>Status:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>
          @switch ((itemObservable | async)?.status) {
            @case (0) {
              <span>Available to Ship</span>
            }
            @case (1) {
              <span>Shipped</span>
            }
            @case (2) {
              <span>Received</span>
            }
            @case (3) {
              <span>Available for Requisition</span>
            }
            @case (4) {
              <span>Requisitioned to Jobsite</span>
            }
          }
        </h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Item Type:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.itemType}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Item Description:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.itemDescription}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Source:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.source}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Destination:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.destination}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Pull:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.pull}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Quantity:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.quantity}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Palletized:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.palletized | boolean}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Pallet #:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.palletNumber}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Flag:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>
          @switch ((itemObservable | async)?.flag) {
            @case (0) {
              <span>Normal</span>
            }
            @case (1) {
              <span>Bypassed Receive Workflow</span>
            }
            @case (2) {
              <span>Bypassed Putaway Workflow</span>
            }
          }
        </h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>Notes:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.notes}}</h4></mat-grid-tile>
        <mat-grid-tile colspan="1"><h4><b>FIFO Date:</b></h4></mat-grid-tile>
        <mat-grid-tile colspan="3"><h4>{{(itemObservable | async)?.fifoDate.toDate() | dateFormat}}</h4></mat-grid-tile>
      </mat-grid-list>
    </mat-card-content>
  </mat-card>
</div>
